// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Bulk Prepare Modal Styles */
.bulk-prepare-modal {
  max-width: 600px;
  width: 90vw;
}

.modal-description {
  color: #666;
  margin-bottom: 24px;
  line-height: 1.5;
  text-align: center;
}

.selection-controls {
  display: flex;
  gap: 12px;
  margin-bottom: 20px;
  justify-content: center;
}

.select-all-button,
.deselect-all-button {
  padding: 8px 16px;
  border: 1px solid #ddd;
  background: #f8f9fa;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s ease;
}

.select-all-button:hover {
  background: #e9ecef;
  border-color: #adb5bd;
}

.deselect-all-button:hover {
  background: #e9ecef;
  border-color: #adb5bd;
}

.language-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 12px;
  margin-bottom: 24px;
  max-height: 300px;
  overflow-y: auto;
  padding: 8px;
  border: 1px solid #eee;
  border-radius: 6px;
  background: #fafafa;
}

.language-checkbox {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  background: white;
  border: 1px solid #e0e0e0;
}

.language-checkbox:hover {
  background: #f5f5f5;
  border-color: #ccc;
}

.language-checkbox.existing {
  border-color: #28a745;
  background: #f8fff9;
}

.language-checkbox.new {
  border-color: #007bff;
  background: #f8f9ff;
}

.language-checkbox input[type="checkbox"] {
  margin: 0;
  cursor: pointer;
}

.language-name {
  font-size: 14px;
  color: #333;
  -webkit-user-select: none;
          user-select: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.language-status {
  font-size: 12px;
  font-weight: bold;
  margin-left: 8px;
}

.language-checkbox.existing .language-status {
  color: #28a745;
}

.language-checkbox.new .language-status {
  color: #007bff;
}

.selected-count {
  text-align: center;
  margin-bottom: 20px;
}

.selected-count p {
  color: #666;
  font-weight: 500;
  margin: 0;
}

.no-languages-available {
  text-align: center;
  padding: 40px 20px;
  color: #666;
  background: #f8f9fa;
  border-radius: 6px;
  margin-bottom: 20px;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 20px;
  border-top: 1px solid #eee;
}

.cancel-button {
  padding: 10px 20px;
  border: 1px solid #ddd;
  background: white;
  color: #666;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s ease;
}

.cancel-button:hover:not(:disabled) {
  background: #f8f9fa;
  border-color: #adb5bd;
}

.start-prepare-button {
  padding: 10px 20px;
  border: none;
  background: #8e44ad; /* Purple color */
  color: white;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.start-prepare-button:hover:not(:disabled) {
  background: #7d3c98;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(142, 68, 173, 0.3);
}

.start-prepare-button:disabled {
  background: #bbb;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.cancel-button:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .bulk-prepare-modal {
    width: 95vw;
    max-width: none;
  }

  .language-grid {
    grid-template-columns: 1fr;
    max-height: 250px;
  }

  .selection-controls {
    flex-direction: column;
    gap: 8px;
  }

  .modal-footer {
    flex-direction: column;
    gap: 8px;
  }

  .start-prepare-button,
  .cancel-button {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/BulkPrepareModal.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,sCAAsC;EACtC,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,yBAAiB;UAAjB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB,EAAE,iBAAiB;EACtC,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;;IAEE,WAAW;EACb;AACF","sourcesContent":["/* Bulk Prepare Modal Styles */\n.bulk-prepare-modal {\n  max-width: 600px;\n  width: 90vw;\n}\n\n.modal-description {\n  color: #666;\n  margin-bottom: 24px;\n  line-height: 1.5;\n  text-align: center;\n}\n\n.selection-controls {\n  display: flex;\n  gap: 12px;\n  margin-bottom: 20px;\n  justify-content: center;\n}\n\n.select-all-button,\n.deselect-all-button {\n  padding: 8px 16px;\n  border: 1px solid #ddd;\n  background: #f8f9fa;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: all 0.2s ease;\n}\n\n.select-all-button:hover {\n  background: #e9ecef;\n  border-color: #adb5bd;\n}\n\n.deselect-all-button:hover {\n  background: #e9ecef;\n  border-color: #adb5bd;\n}\n\n.language-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  gap: 12px;\n  margin-bottom: 24px;\n  max-height: 300px;\n  overflow-y: auto;\n  padding: 8px;\n  border: 1px solid #eee;\n  border-radius: 6px;\n  background: #fafafa;\n}\n\n.language-checkbox {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  background: white;\n  border: 1px solid #e0e0e0;\n}\n\n.language-checkbox:hover {\n  background: #f5f5f5;\n  border-color: #ccc;\n}\n\n.language-checkbox.existing {\n  border-color: #28a745;\n  background: #f8fff9;\n}\n\n.language-checkbox.new {\n  border-color: #007bff;\n  background: #f8f9ff;\n}\n\n.language-checkbox input[type=\"checkbox\"] {\n  margin: 0;\n  cursor: pointer;\n}\n\n.language-name {\n  font-size: 14px;\n  color: #333;\n  user-select: none;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.language-status {\n  font-size: 12px;\n  font-weight: bold;\n  margin-left: 8px;\n}\n\n.language-checkbox.existing .language-status {\n  color: #28a745;\n}\n\n.language-checkbox.new .language-status {\n  color: #007bff;\n}\n\n.selected-count {\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n.selected-count p {\n  color: #666;\n  font-weight: 500;\n  margin: 0;\n}\n\n.no-languages-available {\n  text-align: center;\n  padding: 40px 20px;\n  color: #666;\n  background: #f8f9fa;\n  border-radius: 6px;\n  margin-bottom: 20px;\n}\n\n.modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding-top: 20px;\n  border-top: 1px solid #eee;\n}\n\n.cancel-button {\n  padding: 10px 20px;\n  border: 1px solid #ddd;\n  background: white;\n  color: #666;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: all 0.2s ease;\n}\n\n.cancel-button:hover:not(:disabled) {\n  background: #f8f9fa;\n  border-color: #adb5bd;\n}\n\n.start-prepare-button {\n  padding: 10px 20px;\n  border: none;\n  background: #8e44ad; /* Purple color */\n  color: white;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.start-prepare-button:hover:not(:disabled) {\n  background: #7d3c98;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(142, 68, 173, 0.3);\n}\n\n.start-prepare-button:disabled {\n  background: #bbb;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n.cancel-button:disabled {\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .bulk-prepare-modal {\n    width: 95vw;\n    max-width: none;\n  }\n\n  .language-grid {\n    grid-template-columns: 1fr;\n    max-height: 250px;\n  }\n\n  .selection-controls {\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .modal-footer {\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .start-prepare-button,\n  .cancel-button {\n    width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
